import React from 'react';
import { IIconProps } from '../interfaces';
const GetDemoIcon = (props: IIconProps) => {
    const width = parseInt(props.width);
    const height = (parseInt(props.width) / 19 * 17);
  return (
      <svg width={ width } height={ height } viewBox="0 0 19 17" xmlns="http://www.w3.org/2000/svg">
          <g fill={props.color} fillRule="nonzero">
              <path d="M8.474 14.46 2.758 9.01c-.327-.37-.462-1.078-.084-1.49.373-.407 1.096-.394 1.47.01l4.015 3.832V1.022C8.159.458 8.61 0 9.167 0c.557 0 1.009.458 1.009 1.022v10.34L14.19 7.53c.345-.348 1.094-.413 1.47-.01.378.402.257 1.136-.083 1.49L9.86 14.46a.968.968 0 0 1-.693.276c-.241-.01-.52-.11-.694-.277z"/>
              <path d="M.997 16.736a.999.999 0 0 1-.997-1c0-.552.446-1 .997-1h16.345c.55 0 .996.448.996 1s-.446 1-.996 1H.997z"/>
          </g>
      </svg>
  )
};

export default GetDemoIcon;